'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var init_1 = require("./class/init");
var common_1 = require("./class/common");
var menu_1 = require("./class/menu");
var scroll_1 = require("./class/scroll");
var slick_1 = require("./class/slick");
$(function () {
    new init_1.default();
    new menu_1.default();
    new scroll_1.default.myScroll();
    new scroll_1.default.Common();
    new scroll_1.default.Movie();
    new slick_1.default();
});
// new Limitation();
new common_1.default();
